export default __webpack_public_path__ + "static/media/zona.64097379.jpg";